import { render, staticRenderFns } from "./OffDayManagement.vue?vue&type=template&id=2d6bd806"
import script from "./OffDayManagement.vue?vue&type=script&lang=js"
export * from "./OffDayManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports